import { Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

const MONTHS_FULL_ES = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
]

const MONTHS_SHORT_ES = [
    'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
    'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
]

const WEEKDAYS_SHORT_ES = ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa', 'Do']

@Injectable()
export class I18nSpanish extends NgbDatepickerI18n {

    getWeekdayShortName(weekday: number): string {
        // weekday: 1 = lunes ... 7 = domingo
        return WEEKDAYS_SHORT_ES[weekday - 1]
    }

    getMonthShortName(month: number, year?: number): string {
        return MONTHS_SHORT_ES[month - 1]
    }

    getMonthFullName(month: number, year?: number): string {
        return MONTHS_FULL_ES[month - 1]
    }

    getDayAriaLabel(date: NgbDateStruct): string {
        // Etiqueta aria para accesibilidad
        return `${date.day} de ${MONTHS_FULL_ES[date.month - 1]} de ${date.year}`
    }

    getDayNumerals(date: NgbDateStruct): string {
        return date.day.toString()
    }

    getWeekNumerals(weekNumber: number): string {
        return weekNumber.toString()
    }

    getYearNumerals(year: number): string {
        return year.toString()
    }
}
